import React from 'react';
import { MapContainer, TileLayer, Popup } from 'react-leaflet'



export default function Carte() {
  const position = [43.5240982,5.447246002901208];
  return (
    <MapContainer className="root" center={position} zoom={17} scrollWheelZoom={false} style={{height:'30em'}} zoomControl={true} closePopupOnClick={false}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="http://a.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png "
      />
      <Popup position={position} closeButton={false}> 
        <div style={{textAlign:'center'}}>
          <strong>Marjolaine Benmoussa</strong><br/>
          Graphotherapeute<br/>
          -<br/>
          <em>5, Boulevard du Roi René</em>
        </div>
      </Popup>
    </MapContainer>

  );
}
